import React from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

const ProjectModal = ({ project, isOpen, onClose }) => {
  if (!isOpen || !project) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="relative w-full h-full flex items-center justify-center">
        {/* Close Button */}
        <Button
          onClick={onClose}
          className="absolute top-4 right-4 bg-white hover:bg-gray-100 text-gray-900 rounded-full p-3 z-10"
        >
          <X className="w-6 h-6" />
        </Button>

        {/* Project Image Container */}
        <div 
          className="max-w-7xl max-h-full overflow-auto bg-white rounded-lg"
          onClick={(e) => e.stopPropagation()}
        >
          <img
            src={project.image}
            alt={project.alt}
            className="w-full h-auto object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
